import { render, staticRenderFns } from "./ProjectEditBlocksTab.vue?vue&type=template&id=2f96d520"
import script from "./ProjectEditBlocksTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditBlocksTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports